// extracted by mini-css-extract-plugin
export default {"menu":"_mUWMLn9VDhf0u_hh71U"};